module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "section005"
    }
  }, [_c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', {
    staticClass: "poem_title1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/title_page",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#ch1"
    }
  }, [_vm._v("The Debt")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-Elegy")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swallows")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Year")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inside the Book")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The People’s History")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("House Near the Airport")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consumers in Rowboat")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-Elegy")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  })]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Next Generation")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mind Sliding")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaving the Hospital")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bit about the Soul")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Affair")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayers (w/Answers)")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Report from the Provinces")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image: Postmodernity")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-Elegy")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Language")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  })]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Breath in the Record")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allegory of the House")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-Elegy")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Landings")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  })]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ballad (American, 21st Century)")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoax Bomb")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Notes on Human Relations")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image: Psychotherapy")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21st Century Museum")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Harper, 20 Months Old")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allegory of the Boat")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-Elegy")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Breathing")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Envoi")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/Notes#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/Author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3a7668","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Toc.vue
// module id = 78
// module chunks = 0